import { HealthRecordDocumentUploadMetadata } from '@web/csl-lib-models';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SERVICE_CONFIG_TOKEN, ServiceConfig } from '@web/csl-lib-services';
import { StoredHealthRecordDocument } from '@web/csl-lib-models';

@Injectable({
  providedIn: 'root'
})
export class HealthRecordDocumentsService {

  private serviceConfig: ServiceConfig;
  private http!: HttpClient;
  private readonly apiUrl! : string;

  constructor() {
    this.http = inject(HttpClient);
    this.serviceConfig = inject(SERVICE_CONFIG_TOKEN);
    this.apiUrl = this.serviceConfig.apiUrl;
  }

  getAllMeta(clinicId: number | null, healthRecordId: string) : Observable<StoredHealthRecordDocument[]> {
    if(clinicId) {
      return this.http.get<StoredHealthRecordDocument[]>(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/documents`);
    }
    return this.http.get<StoredHealthRecordDocument[]>(`${this.apiUrl}/healthrecords/${healthRecordId}/documents`);
  }

  get(healthRecordId: string, fileKey: string, clinicId?: number): Observable<ArrayBuffer> {
    if(clinicId) {
      return this.http.get(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/documents/${fileKey}`,
        { responseType: 'arraybuffer' }
      );
    }
    return this.http.get(`${this.apiUrl}/healthrecords/${healthRecordId}/documents/${fileKey}`,
      { responseType: 'arraybuffer' }
    );
    // https://stackoverflow.com/questions/46408537/angular-httpclient-http-failure-during-parsing
  }

  upload(healthRecordId: string, file: File, metadata: HealthRecordDocumentUploadMetadata, clinicId?: number | null): Observable<StoredHealthRecordDocument> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('fileDate', new Date(file.lastModified).toISOString());
    formData.append('comment', metadata.comment ?? '');
    formData.append('documentDate', (metadata.documentDate ?? new Date()).toISOString());
    formData.append('documentType', String(metadata.documentType ?? ''));
    formData.append('storageDestination', metadata.storageDestination);

    // Do not set a Content-Type header here - the browser must set it (including the multipart boundary) automatically.
    if(clinicId) {
      return this.http.post<StoredHealthRecordDocument>(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/documents`, formData);
    }
    return this.http.post<StoredHealthRecordDocument>(`${this.apiUrl}/healthrecords/${healthRecordId}/documents`, formData);
  }

  delete(healthRecordId: string, fileStoreId: string, clinicId?: number | null) {
    if(clinicId) {
      return this.http.delete(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/documents/${fileStoreId}`);
    }
    return this.http.delete(`${this.apiUrl}/healthrecords/${healthRecordId}/documents/${fileStoreId}`);
  }

}
